import React from 'react';
import './BotBadge.scss';

interface BotBadgeProps {
  /** Server-driven — never client-picked. Pass isBot from the API
   *  response verbatim; falsy = don't render. */
  isBot?: boolean | null;
  className?: string;
}

/**
 * "🤖 Bot" disclosure badge. Renders inline next to a display name
 * (profile page, message bubble, post card, wherever a bot's
 * identity appears) so viewers always know the counterparty is
 * not human. Required by docs/klyx_bots.md.
 *
 * Server-driven only — never derived on the client. If the API
 * says `isBot: true`, badge shows; otherwise it doesn't. Users
 * can't opt bots out; bots can't opt themselves out.
 */
const BotBadge: React.FC<BotBadgeProps> = ({ isBot, className = '' }) => {
  if (!isBot) return null;
  return (
    <span
      className={`bot-badge ${className}`.trim()}
      title="This account is an automated Klyx bot, not a human."
    >
      🤖 Bot
    </span>
  );
};

export default BotBadge;
